export default __webpack_public_path__ + "locales/tr/UploadPanel.json?hash=04d0152ccbe403e4e9214accccc11bbc";